import {Link, useNavigate, useParams} from "react-router-dom";
import { getUserDetails, saveUserDetails } from "../../services/UserService";
import {useEffect, useState} from "react";
import {IUser} from "../../interfaces/IUser";

const EditUser = () => {

    const [state, setState] = useState({
        userDetails: {} as IUser,
        loading: false,
        hasError: false,
    });
    let { id } = useParams();
    let navigate = useNavigate();

    useEffect(() => {
        const __init = async () => {
            const user = await getUserDetails(id);         

            setState({...state, userDetails: user})
        }

        __init()
    }, []);

    const onInputChange = (key: string, val: any) => {
        const value = val.target ? val.target.value : '';

        setState({
            ...state, userDetails: {
                ...state.userDetails, [key]: value
            }
        });
    }

    const onSave = async (id: any) => {

        const res = await saveUserDetails(id, state.userDetails);

        if (res) {
            setState({...state, loading: false})
            navigate('/users')
        }
    };

    return <div className="content-header">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-header">
                                    <h3 className="card-title text-uppercase">User Details</h3>
                                    {/*<Link to={`/users/reset-password/${state.userDetails.id}`} className="float-right text-dark" style={{textDecoration: "underline"}}>Reset password</Link>*/}
                                    <a></a>
                                </div>

                                <div className="form-horizontal">
                                    <div className="card-body">
                                        <div className="form-group row">
                                            <label htmlFor="first_name" className="col-sm-3 col-form-label">User name</label>
                                            <div className="col-sm-9">
                                                <input type="text" className={`form-control`} id="name"
                                                    placeholder="Name" onChange={(val: any) => onInputChange('name', val)} defaultValue={state.userDetails.name}/>
                                            </div>
                                        </div>

                                        <div className="form-group row">
                                            <label htmlFor="last_name" className="col-sm-3 col-form-label">Email</label>
                                            <div className="col-sm-9">
                                                <input type="text" className={`form-control`} id="email"
                                                    placeholder="Email" onChange={(val: any) => onInputChange('email', val)} defaultValue={state.userDetails.email}/>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="card-footer">
                                        <button type="submit" className="btn btn-info" onClick={() => onSave(id)}>
                                            {state.loading ? 'Saving...' : 'Save changes'}
                                        </button>
                                        <Link to={'/users'} className="btn btn-default float-right">Cancel</Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
};

export default EditUser;
